var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MonacoEditor',{attrs:{"language":"javascript"}})
}
var staticRenderFns = []

export { render, staticRenderFns }